import { render, staticRenderFns } from "./RaceNames.vue?vue&type=template&id=10a055fe"
import script from "./RaceNames.vue?vue&type=script&lang=js"
export * from "./RaceNames.vue?vue&type=script&lang=js"
import style0 from "./RaceNames.vue?vue&type=style&index=0&id=10a055fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports